import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DashboardLayout from "../../../components/layout/DashboardLayout";
import ResourceList from "../../../components/resourceList/ResourceList";
import { fetchTaxpayers } from "../../../store/actions/admin/taxPayers";
import styles from "./Taxpayers.module.scss";
import Input from "../../../components/input/Input";
import _ from "lodash";
import classNames from "classnames";

const HEADER_VALUES = [
  { label: "NAZIV", key: "name", sortable: true },
  { label: "PIB", key: "PIB", sortable: true },
  { label: "ADRESA", key: "address", sortable: false },
  { label: "KORISNICI", key: "users", sortable: false },
  { label: "AKCIJE", sortable: false },
];

const Taxpayers = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const taxpayers = useSelector((state) => state.taxpayers.taxpayers);
  const { page, perPage, total, data, attempt } = taxpayers || {};

  const [searchTerm, setSearchTerm] = useState("");

  const searchTaxpayers = _.debounce((searchTerm) => {
    dispatch(fetchTaxpayers(1, perPage || 15, searchTerm));
  }, 600);

  useEffect(() => {
    dispatch(fetchTaxpayers(1, 15, ""));
  }, [dispatch]);

  useEffect(() => {
    searchTaxpayers(searchTerm);
  }, [searchTerm]);

  const onLoadPage = (newPage) => {
    dispatch(fetchTaxpayers(newPage, perPage || 15, searchTerm));
  };

  const onSort = (sortBy, order) => {
    // Sorting can be implemented if needed
    dispatch(fetchTaxpayers(1, perPage || 15, searchTerm));
  };

  const renderCompanyRow = (company, index) => {
    const address = company.address?.name || "-";
    const userCount = company.users?.length || 0;

    return (
      <div
        className={classNames(styles.row, index % 2 === 0 ? styles.even : styles.odd)}
        key={company.id}
        onClick={() => history.push(`/companies/${company.id}`)}
      >
        <div className={styles.cell}>
          <p className={styles.companyName}>{company.name || "-"}</p>
        </div>
        <div className={styles.cell}>
          <p>{company.PIB || "-"}</p>
        </div>
        <div className={styles.cell}>
          <p>{address}</p>
        </div>
        <div className={styles.cell}>
          <p>{userCount}</p>
        </div>
        <div className={styles.cell}>
          <button
            className={styles.viewButton}
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/companies/${company.id}`);
            }}
          >
            Pregled
          </button>
        </div>
      </div>
    );
  };

  return (
    <DashboardLayout>
      <div className={styles.dashboardContent}>
        <div className={styles.topPart}>
          <p className={styles.title}>Obveznici</p>
          <div className={styles.flexEnd}>
            <div className={styles.inputWrapper}>
              <Input
                onChange={(value) => {
                  setSearchTerm(value);
                }}
                value={searchTerm}
                placeholder={searchTerm === "" && "Search"}
              />
            </div>
          </div>
        </div>
        <div className={styles.listWrapper}>
          <ResourceList
            resource={{
              data: data || [],
              total: total || 0,
              page: page || 1,
              perPage: perPage || 15,
              attempt: attempt || false,
            }}
            headerValues={HEADER_VALUES}
            onLoadPage={onLoadPage}
            onSort={onSort}
            rowRender={renderCompanyRow}
            showLoader={true}
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Taxpayers;
